import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import {AnalisesCondicionadasService} from 'src/app/services/analisesCondicionadas.service';
import { AnalisesCondicionadas } from 'src/app/model/AnalisesCondicionadas';

@Component({
  selector: 'app-analise-condicionadas',
  templateUrl: './analise-condicionadas.component.html',
  styleUrls: ['./analise-condicionadas.component.scss'],
  standalone: false
})
export class AnaliseCondicionadasComponent implements OnInit {
  
  @Output() exibirAnaliseCondicionadasEmitter = new EventEmitter<boolean>();
  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  analisesList: AnalisesCondicionadas[];
  
  constructor(private analisesCondicionadasService: AnalisesCondicionadasService) { }

  ngOnInit(): void {
    this.analisesCondicionadasService.obterAnalisesCondicionadas(this.documentoPac.id).subscribe(
      (analises) =>{         
        this.exibirAnaliseCondicionadasEmitter.emit(true);
        this.analisesList = analises;
      },
      (error)=>{
        if(error.status == 401 || error.status == 403){
          this.exibirAnaliseCondicionadasEmitter.emit(false);
        }
        console.error(`Erro ao pesquisar lista de Analises Condicionadas: ${error}`);
      }
    );
  }

}
